<template>
    <HeaderCardsLayout variant="No-Logo">
        <template #headline>{{ $t('project-wiki') }}</template>
        <template #icon>
            <ConstructionIcon class="w-12 h-12" />
        </template>
        <template #buttons>
            <LinkButton
                variant="Info-Strong"
                size="Base"
                :disabled-explanation="createProjectSeriesDisabledExplanation"
                :to="getCreateProjectSeriesLink()"
            >
                <template #icon>
                    <PlusIcon class="size-5" />
                </template>
                {{ $t('project-series-create') }}
            </LinkButton>
        </template>
        <template #body>
            <PaddedContent>
                <ProjectSeriesList />
            </PaddedContent>
        </template>
    </HeaderCardsLayout>
</template>

<script setup lang="ts">
import auth from '@/auth/auth';
import LinkButton from '@/components/Button/LinkButton.vue';
import ConstructionIcon from '@/components/Icon/ConstructionIcon.vue';
import PlusIcon from '@/components/Icon/PlusIcon.vue';
import HeaderCardsLayout from '@/components/Layout/HeaderCardsLayout.vue';
import PaddedContent from '@/components/Layout/PaddedContent.vue';
import { useHeadSafe } from '@unhead/vue';
import { useFluent } from 'fluent-vue';
import { computed } from 'vue';
import ProjectSeriesList from '../components/ProjectSeriesList.vue';
import { getCreateProjectSeriesLink } from '../project';

const fluent = useFluent();
useHeadSafe({ title: () => fluent.$t('project-wiki') });

const createProjectSeriesDisabledExplanation = computed(() =>
    auth.isAdmin() ? undefined : fluent.$t('no-permission-to-create'),
);
</script>
